import { HttpErrorResponse } from '@angular/common/http';
import { DropDownListDTO, DropDownListSiteRecebimentoDTO } from './../../entity/dto/dropdownlist.component';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { take } from 'rxjs/operators';
import { FormCamisaTrieurFilter } from 'src/app/entity/models/form-camisa-trieur-filter';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { GeneralFilterComponent } from 'src/app/shared/general-filter.component';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';

@Component({
    selector: 'app-form-camisa-trieur-filter',
    templateUrl: './form-camisa-trieur-filter.component.html',
    styleUrls: ['./form-camisa-trieur-filter.component.scss']
})

export class FormCamisaTrieurFilterComponent extends GeneralFilterComponent implements OnInit {

    public formulario?: FormGroup;
    @Output() filter = new EventEmitter();
    public listSafra?: DropDownListDTO[] = new Array<DropDownListDTO>();
    public listHibrido?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listHibridoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    constructor(protected formBuilder: FormBuilder, protected formularioService: FormularioService,
        // tslint:disable-next-line: align
        protected notificationService: NotificationService, protected generalService: GeneralService) {
        super();
        this.formulario = this.formBuilder.group({
            created_at_inicial: ['', []],
            created_at_final: ['', []],
            site_recebimento: ['', []],
            safra: ['', []],
            hibrido_rnc_linhagem: ['', []],
            responsavel_lancamento: ['', []],
        });
    }

    async ngOnInit(): Promise<void> {
        Promise.all([
            this.getLists(),
            this.getFilters(),
            this.formulario.get('site_recebimento').setValue(this.generalService.getLocalStorageDataSite())
        ])
    }

    async sendFilter(): Promise<void> {
        this.filter.emit(await this.buildFilter());
    }

    async clearFilter(): Promise<void> {
        this.formulario.reset();
    }

    async buildFilter(): Promise<FormCamisaTrieurFilter> {
        const formulario: FormCamisaTrieurFilter = new FormCamisaTrieurFilter();
        formulario.created_at_inicial = !!this.formulario.get('created_at_inicial')?.value ? this.generalService.createDate(this.formulario.get('created_at_inicial')?.value) : null;
        formulario.created_at_final = !!this.formulario.get('created_at_final')?.value ? this.generalService.createDate(this.formulario.get('created_at_final')?.value) : null;
        formulario.site = this.formulario.get('site_recebimento')?.value;
        formulario.safra = this.formulario.get('safra')?.value;
        formulario.hibrido_rnc = this.formulario.get('hibrido_rnc_linhagem')?.value;
        formulario.responsavel_lancamento = this.formulario.get('responsavel_lancamento')?.value;
        return formulario;
    }

    async getLists(): Promise<void> {
        await Promise.all([
            this.getListSafra(),
            this.getListHibridoRNC(),
            this.createFilterHibrido()
        ]);
    }


    async getFilters(): Promise<void> {
        await Promise.all([
        ]);
    }

    async getListSafra(): Promise<void> {
        this.formularioService.getListDropDownList('qua007', 'safra').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listSafra = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSafra);
        });
    }

    async getListHibridoRNC(): Promise<void> {
        await this.formularioService
            .getListDropDownList('qua007', 'hibrido_rnc')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listHibrido = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                    this.listHibridoOriginal = this.listHibrido;
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorHibrido
                );
            });
    }

    async createFilterHibrido(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (
                this.listHibridoOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                ).length > 0
            ) {
                this.listHibrido = this.listHibridoOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                );
            } else {
                this.listHibrido = this.listHibridoOriginal;
            }
        } else {
            this.listHibrido = this.listHibridoOriginal;
        }
    }

}
